/* compare_line_by_line_icon.svg.js */

"use strict";
module.exports = {
    icon: `    
    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 22.7 20.5" style="enable-background:new 0 0 22.7 20.5;" xml:space="preserve">
		<style type="text/css">
			.st0{fill:#59595C;}
		</style>
		<path class="st0" d="M20.2,12.3H2.6c-1.2,0-2.2-0.9-2.2-2c0-1.1,1-2,2.2-2h17.6c1.2,0,2.2,0.9,2.2,2C22.4,11.4,21.4,12.3,20.2,12.3z
			"/>
		<path class="st0" d="M20.2,6.3H2.6c-1.2,0-2.2-0.9-2.2-2s1-2,2.2-2h17.6c1.2,0,2.2,0.9,2.2,2S21.4,6.3,20.2,6.3z"/>
		<path class="st0" d="M20.2,18.3H2.6c-1.2,0-2.2-0.9-2.2-2s1-2,2.2-2h17.6c1.2,0,2.2,0.9,2.2,2S21.4,18.3,20.2,18.3z"/>
</svg>
         `,
};
